module.exports = __webpack_public_path__ + "images/internal/datashake/icons/it_central_station.svg";